<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    modal-class="ocorrencia-modal"
    no-close-on-backdrop
    v-model="showModal"
    @ok="handleOk"
    @show="beforeOpen"
    @hide="onHide"
    @hidden="cancelUpload"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="fileForm.errors.clear($event.target.name)"
    >
      <div class="ocorrencia-form__row">
        <div class="ocorrencia-form__item ocorrencia-form__item--type">
          <label class="ocorrencia-form__label"
            ><span class="ocorrencia-form__required">*</span> Tipo ocorrência</label
          >
          <multiselect
            v-model="codOcorrencia"
            :options="this.$parent.optionsCodOcorrencia"
            track-by="value"
            label="label"
            :hide-selected="true"
            placeholder="Digite o nome ou o código da ocorrência"
            tag-placeholder=""
            select-label=""
            selected-label="Selecionado"
            deselect-label="Remover"
          ></multiselect>
          <p
            class="ocorrencia-form__error"
            v-text="fileForm.errors.get('cd_ocorrencia')"
            v-if="fileForm.errors.has('cd_ocorrencia')"
          ></p>
          <p class="ocorrencia-form__error" v-if="isSingleInvoiceRequired">
            Com código de devolução, lance uma nota por vez.
          </p>
        </div>
        <div class="ocorrencia-form__item">
          <label class="ocorrencia-form__label" for="codigo_devolucao"
            ><span class="ocorrencia-form__required" v-if="isReturnCodeEnabled"
              >*</span
            >
            Código de devolução</label
          >
          <input
            id="codigo_devolucao"
            name="codigo_devolucao"
            type="text"
            class="ocorrencia-form__input"
            :class="{
              'ocorrencia-form__input--error': fileForm.errors.has(
                'codigo_devolucao'
              ),
            }"
            :disabled="!isReturnCodeEnabled"
            v-model="fileForm.codigo_devolucao"
            @input="onReturnCodeInput"
            autocomplete="off"
            maxlength="4"
            placeholder="A01N"
          />
          <p
            class="ocorrencia-form__error"
            v-text="fileForm.errors.get('codigo_devolucao')"
            v-if="fileForm.errors.has('codigo_devolucao')"
          ></p>
          <p
            class="ocorrencia-form__notice"
            v-if="isReturnCodeNotice"
          >
            Nota baixada pelo painel: o código não é exigido.
          </p>
        </div>
      </div>
      <div class="ocorrencia-form__row">
        <div class="ocorrencia-form__item ocorrencia-form__item--type">
          <label class="ocorrencia-form__label" for="dia">Período</label>
          <input
            id="dia"
            type="text"
            class="ocorrencia-form__input"
            :class="{
              'ocorrencia-form__input--error': fileForm.errors.has(
                'dt_ocorrencia'
              ),
            }"
            v-model="fileForm.dt_ocorrencia"
            name="dia"
            v-mask="mascaraDia"
            :disabled="!editarData"
          />
          <p
            class="ocorrencia-form__error"
            v-text="fileForm.errors.get('dt_ocorrencia')"
            v-if="fileForm.errors.has('dt_ocorrencia')"
          ></p>
        </div>
        <div class="ocorrencia-form__item">
          <label class="ocorrencia-form__label" for="num_carga"
            ><span class="ocorrencia-form__required" v-if="isLoadNumberRequired"
              >*</span
            >
            Número da carga</label
          >
          <input
            id="num_carga"
            name="num_carga"
            type="text"
            class="ocorrencia-form__input"
            :class="{
              'ocorrencia-form__input--error': fileForm.errors.has('num_carga'),
            }"
            v-model="fileForm.num_carga"
            autocomplete="off"
            placeholder="Ex: 84325"
          />
          <p
            class="ocorrencia-form__error"
            v-text="fileForm.errors.get('num_carga')"
            v-if="fileForm.errors.has('num_carga')"
          ></p>
        </div>
      </div>
      <div class="ocorrencia-form__item">
        <label class="ocorrencia-form__label" for="obs"
          ><span class="ocorrencia-form__required">*</span> Descrição da
          ocorrência</label
        >
        <textarea
          id="obs"
          name="obs"
          class="ocorrencia-form__textarea"
          :class="{
            'ocorrencia-form__input--error': fileForm.errors.has('obs'),
          }"
          v-model="fileForm.obs"
          maxlength="200"
          placeholder="Digite aqui uma descrição para esse roteiro"
        ></textarea>
        <div class="ocorrencia-form__counter">{{ obsLength }} / 200</div>
        <p
          class="ocorrencia-form__error"
          v-text="fileForm.errors.get('obs')"
          v-if="fileForm.errors.has('obs')"
        ></p>
      </div>
      <div class="ocorrencia-form__item">
        <label class="ocorrencia-form__label"
          >Anexar comprovante
          <span class="ocorrencia-form__optional">(opcional)</span></label
        >
        <div
          class="ocorrencia-upload"
          :class="{ 'ocorrencia-upload--drag': dragging }"
          @click="$refs.fileInput.click()"
          @dragover.prevent="dragging = true"
          @dragleave.prevent="dragging = false"
          @drop.prevent="onDrop"
        >
          <span class="ocorrencia-upload__icon"><i class="fa fa-upload"></i></span>
          <p class="ocorrencia-upload__title">
            Clique ou solte o arquivo para esta área para fazer o upload.
          </p>
          <p class="ocorrencia-upload__hint">PNG, JPG, PDF · até 10MB</p>
          <input
            ref="fileInput"
            type="file"
            multiple
            hidden
            :accept="shouldRestrictAttachments ? '.png,.jpg,.jpeg,.pdf' : null"
            @click.stop
            @change="onFileInputChange"
          />
        </div>
        <ul class="ocorrencia-attachments" v-if="attachments.length">
          <li
            v-for="(item, index) in attachments"
            :key="index"
            class="ocorrencia-attachment"
            :class="{
              'ocorrencia-attachment--error':
                item.status === 'too_large' ||
                item.status === 'invalid_type' ||
                item.status === 'failed',
            }"
          >
            <div class="ocorrencia-attachment__info">
              <div class="ocorrencia-attachment__name">{{ item.file.name }}</div>
              <div class="ocorrencia-attachment__status">
                <template v-if="item.status === 'uploading'">
                  <div class="ocorrencia-attachment__bar">
                    <div
                      class="ocorrencia-attachment__bar-fill"
                      :style="{ width: item.progress + '%' }"
                    ></div>
                  </div>
                  <a
                    href="#"
                    v-if="uploadProgress < 100"
                    @click.prevent="cancelUpload"
                    >Cancelar</a
                  >
                  <span v-else>Aguardando resposta…</span>
                </template>
                <template v-else-if="item.status === 'too_large'"
                  >O arquivo excede o tamanho máximo (10MB).</template
                >
                <template v-else-if="item.status === 'invalid_type'"
                  >Formato de arquivo não permitido. Use PNG, JPG ou
                  PDF.</template
                >
                <template v-else-if="item.status === 'failed'"
                  >Falha ao enviar o documento. Tente novamente</template
                >
                <template v-else
                  >{{ formatSize(item.file.size) }} ·
                  <span class="ocorrencia-attachment__ready">Pronto</span></template
                >
              </div>
            </div>
            <div class="ocorrencia-attachment__actions">
              <a
                href="#"
                title="Reenviar"
                v-if="item.status === 'failed'"
                @click.prevent="retryAttachment(item)"
                ><i class="fa fa-refresh"></i
              ></a>
              <a
                href="#"
                title="Remover"
                v-if="item.status !== 'uploading'"
                @click.prevent="removeAttachment(index)"
                ><i class="fa fa-times"></i
              ></a>
            </div>
          </li>
        </ul>
      </div>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn
          class="ocorrencia-btn ocorrencia-btn--back"
          @click="showModal = false"
        >
          Voltar
        </b-btn>
        <b-btn
          class="ocorrencia-btn ocorrencia-btn--submit"
          @click="handleOk($event)"
          :disabled="isSubmitDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import Cookies from "js-cookie";
import { apiVersion } from "../main.js";
import { resolveApiBase } from "../shared/utils/resolveApiBase";

const OCORRENCIA_CD_DEVOLVIDO_NO_CD = 196;
const RETURN_CODE_PATTERN = /^[A-Z0-9]{4}$/;
const MAX_FILE_BYTES = 10 * 1024 * 1024;
const ALLOWED_FILE_TYPES = ["image/png", "image/jpeg", "application/pdf"];
const ALLOWED_FILE_EXTENSION = /\.(png|jpe?g|pdf)$/i;

export default {
  components: {
    AvisoErros,
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: "",
  },
  data() {
    return {
      editarData: this.getPermission("alterar.data.ocorrencia"),
      dataExport: [],
      codOcorrencia: [],
      notas: [],
      docfisIds: [],
      attachments: [],
      dragging: false,
      abortController: null, // axios CancelToken source
      uploadProgress: 0,
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      statusSelected: [],
      mascaraDia: "##/##/#### ##:##",
      optionsCodOcorrencia: [],
      errors_array: [],
      data: [],
      form: new Form({
        cd_ocorrencia: "",
        dt_ocorrencia: "",
        obs: "",
        docfis: [],
      }),
      fileForm: new FileForm({
        file: [],
        data: [],
        cd_ocorrencia: "",
        dt_ocorrencia: "",
        num_carga: "",
        codigo_devolucao: "",
        obs: "",
        docfis: [],
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  watch: {
    codOcorrencia(obj) {
      this.fileForm.cd_ocorrencia = obj && obj.value ? obj.value : "";
      this.clearReturnCodeIfDisabled();
    },
  },
  methods: {
    onReturnCodeInput() {
      this.fileForm.codigo_devolucao = String(this.fileForm.codigo_devolucao)
        .replace(/[^a-z0-9]/gi, "")
        .toUpperCase();
    },
    clearReturnCodeIfDisabled() {
      if (!this.isReturnCodeEnabled) {
        this.fileForm.codigo_devolucao = "";
        this.fileForm.errors.clear("codigo_devolucao");
      }
    },
    formatSize(bytes) {
      return (bytes / (1024 * 1024)).toFixed(2) + " MB";
    },
    onFileInputChange(event) {
      this.addFiles(Array.from(event.target.files));
      event.target.value = "";
    },
    onDrop(event) {
      this.dragging = false;
      this.addFiles(Array.from(event.dataTransfer.files));
    },
    addFiles(files) {
      const items = files.map((file) => ({
        file,
        status: this.attachmentStatus(file),
        progress: 0,
      }));
      this.attachments = this.attachments.concat(items);
    },
    /** Tipo e tamanho só são restringidos em unidade ligada; o file.type vazio (comum em PDF) cai na extensão. */
    attachmentStatus(file) {
      if (!this.shouldRestrictAttachments) {
        return "ready";
      }
      const typeAllowed = file.type
        ? ALLOWED_FILE_TYPES.includes(file.type)
        : ALLOWED_FILE_EXTENSION.test(file.name);
      if (!typeAllowed) {
        return "invalid_type";
      }
      return file.size > MAX_FILE_BYTES ? "too_large" : "ready";
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
    },
    retryAttachment(item) {
      item.status = "ready";
      item.progress = 0;
    },
    /** Com o corpo todo enviado o servidor pode já ter gravado: não dá para cancelar nem fechar até a resposta. */
    onHide(event) {
      if (this.abortController && this.uploadProgress >= 100) {
        event.preventDefault();
      }
    },
    cancelUpload() {
      if (this.abortController && this.uploadProgress < 100) {
        this.abortController.cancel();
        this.abortController = null;
      }
    },
    handleOk(e) {
      e.preventDefault();
      if (this.isSubmitDisabled) {
        return;
      }
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.feriado_id);
      }
    },
    onCreate(data, notas) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Informar ocorrência";
      this.modal_botao = "Enviar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.errors_array = [];
      this.fileForm.reset();
      this.codOcorrencia = [];
      this.fileForm.file = [];
      this.attachments = [];
      this.docfisIds = data || [];
      this.notas = notas || [];
      this.fileForm.docfis = data;
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.errors_array = "";
      this.errors_array = [];
      this.municipioSelected = [];
      this.ufSelected = [];
      this.tpFeriadoSelected = [];
      this.form.feriado_id = data.feriado_id;
      this.form.ano = data.ano;
      this.form.diaMes = data.dia + "/" + data.mes;
      this.form.descr = data.descr;
      this.form.status = data.status.valor;
      this.form.feriado_anual = data.feriado_anual.valor;
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor,
      };
      if (data.rel_feriado_uf != null) {
        this.ufSelected = {
          label: data.rel_feriado_uf.uf.nome,
          value: data.rel_feriado_uf.uf.uf_id,
        };
      }
      if (data.rel_feriado_municipio != null) {
        this.ufSelected = {
          label: data.rel_feriado_municipio.municipio.uf.nome,
          value: data.rel_feriado_municipio.municipio.uf.uf_id,
        };
        this.municipioSelected = {
          label: data.rel_feriado_municipio.municipio.nome,
          value: data.rel_feriado_municipio.municipio.municipio_id,
        };
      }
      this.tpFeriadoSelected = {
        label: data.tp_feriado.descr,
        value: data.tp_feriado.valor,
      };
      this.form.param_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.arrayNomeFile = [];
      this.data = [];
      this.data.push({
        label: "cd_ocorrencia",
        value: this.fileForm.cd_ocorrencia,
      });
      this.data.push({ label: "arquivos[]", value: this.fileForm.file });
      this.fileForm.file = this.attachments
        .filter((item) => item.status === "ready")
        .map((item) => item.file);
      if (this.getPermission("alterar.data.ocorrencia")) {
        this.data.push({
          label: "dt_ocorrencia",
          value: this.fileForm.dt_ocorrencia,
        });
      } else {
        this.data.push({
          label: "dt_ocorrencia",
          value: "",
        });
      }
      this.data.push({ label: "obs", value: this.fileForm.obs });
      this.data.push({
        label: "docfis",
        value: this.fileForm.docfis.toString(),
      });
       this.data.push({
        label: "num_carga",
        value: this.fileForm.num_carga,
      });
      if (this.isReturnCodeEnabled) {
        this.data.push({
          label: "codigo_devolucao",
          value: this.fileForm.codigo_devolucao,
        });
      }
      this.fileForm.data = this.data;

      const formData = new FormData();
      this.fileForm.data.forEach((item) => {
        if (item.label != "arquivos[]") {
          formData.append(item.label, item.value);
        }
      });
      for (let i = 0; i < this.fileForm.file.length; i++) {
        formData.append("arquivos[]", this.fileForm.file[i]);
      }

      const base = resolveApiBase(apiVersion());

      const sending = this.attachments.filter((item) => item.status === "ready");
      sending.forEach((item) => {
        item.status = "uploading";
        item.progress = 0;
      });
      // axios 0.19 não suporta `signal`; o cancelamento é via CancelToken
      this.abortController = axios.CancelToken.source();
      this.uploadProgress = 0;

      axios
        .post(base + "/api/inclusaoocorrencia/store", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-XSRF-TOKEN": Cookies.get("XSRF-TOKEN"),
          },
          cancelToken: this.abortController.token,
          onUploadProgress: (event) => {
            if (!event.total) {
              return;
            }
            const percent = Math.round((event.loaded * 100) / event.total);
            this.uploadProgress = percent;
            sending.forEach((item) => {
              item.progress = percent;
            });
          },
        })
        .then((response) => {
          this.abortController = null;
          this.fileForm.onSuccess(response.data);
          response.data.httpStatus = response.status;
          new ReturnApi(response.data, this, null, false);
          Vue.nextTick(() => this.$refs.vuetable.refresh());
        })
        .catch((error) => {
          this.abortController = null;
          this.loading = false;
          this.isDisabled = false;
          if (!error.response) {
            if (axios.isCancel(error)) {
              sending.forEach((item) => {
                item.status = "ready";
              });
              return;
            }
            // sem resposta o servidor pode ter gravado: avisa e atualiza a grade antes de um reenvio
            sending.forEach((item) => {
              item.status = "failed";
            });
            this.errors_array = [
              {
                erro:
                  "Não foi possível confirmar o envio. Confira a listagem antes de tentar novamente.",
              },
            ];
            this.refreshParentGrid();
            return;
          }
          sending.forEach((item) => {
            item.status = "ready";
          });
          if (error.response.status == 401) {
            console.log(error);
          }
          const data = error.response.data;
          if (data && data.type == 3) {
            this.fileForm.errors.record(data.errors, data.message, data.type);
          }
          new ReturnApi(data || {}, this, true, null, null, false);
          this.errors_array = this.buildInclusaoOcorrenciaErrorsForAviso(data);
        });
    },
    refreshParentGrid() {
      const vuetable = this.$parent.$refs.vuetable;
      if (vuetable) {
        vuetable.refresh();
      }
    },
    /** Linhas para o AvisoErros (laranja no rodapé do modal); sem toast Snotify. */
    buildInclusaoOcorrenciaErrorsForAviso(payload) {
      if (!payload || typeof payload !== "object") {
        return [];
      }
      const items = [];
      if (payload.type === 3 && (payload.message || payload.title)) {
        let line = "";
        if (payload.title) {
          line += `<strong>${payload.title}</strong>`;
        }
        if (payload.message) {
          line += (line ? "<br>" : "") + payload.message;
        }
        items.push({ erro: line });
      }
      const wrapped =
        payload.errors !== undefined &&
        (payload.type === 3 ||
          payload.message !== undefined ||
          payload.title !== undefined ||
          payload.tp_message !== undefined);
      const raw = wrapped ? payload.errors : payload;
      items.push(...this.flattenInclusaoOcorrenciaErrorValues(raw));
      return items;
    },
    flattenInclusaoOcorrenciaErrorValues(raw) {
      const out = [];
      if (raw == null || raw === "") {
        return out;
      }
      if (typeof raw === "string") {
        out.push({ erro: raw });
        return out;
      }
      if (Array.isArray(raw)) {
        raw.forEach((item) => {
          if (item == null) {
            return;
          }
          if (typeof item === "string") {
            out.push({ erro: item });
          } else {
            out.push(...this.flattenInclusaoOcorrenciaErrorValues(item));
          }
        });
        return out;
      }
      if (typeof raw === "object") {
        Object.keys(raw).forEach((key) => {
          const val = raw[key];
          if (Array.isArray(val)) {
            val.forEach((msg) => {
              if (msg != null && msg !== "") {
                out.push({ erro: String(msg) });
              }
            });
          } else if (val != null && typeof val === "object") {
            out.push(...this.flattenInclusaoOcorrenciaErrorValues(val));
          } else if (val != null && val !== "") {
            out.push({ erro: String(val) });
          }
        });
      }
      return out;
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      console.log(id);
      this.form
        .patch("/api/feriado/update/" + id)
        .then((response) => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/feriado/status")
        .then((response) => {
          new ReturnApi(response, this);

          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
    // adicionado metodo ao abrir o modal carregar data e hora atual
    beforeOpen() {
      this.fileForm.dt_ocorrencia = this.getCurrentDateTime();
    },
    // metodo de data e hora do campo dt_ocorrencia
    getCurrentDateTime() {
      const now = new Date();
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const year = now.getFullYear();
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");

      const formattedDateTime = `${day}/${month}/${year} ${hours}:${minutes}`;
      return formattedDateTime;
    },
  },
  computed: {
    obsLength() {
      return String(this.fileForm.obs || "").trim().length;
    },
    isReturnOccurrence() {
      return (
        Number(this.codOcorrencia && this.codOcorrencia.cd) ===
        OCORRENCIA_CD_DEVOLVIDO_NO_CD
      );
    },
    /** Unidade ligada + 196: número da carga obrigatório (inclusive em nota dispensada do código). */
    isLoadNumberRequired() {
      return this.$parent.exigeCodigoDevolucao === true && this.isReturnOccurrence;
    },
    /** Nota baixada pelo painel: a API devolve dispensa_codigo_devolucao por nota; nota fora da grade atual não é dispensada. */
    isReturnCodeWaived() {
      // a API só aceita uma nota por vez na 196 com código; a dispensa vale para essa nota
      return (
        this.docfisIds.length === 1 &&
        this.notas.length === 1 &&
        this.notas[0].dispensa_codigo_devolucao === true
      );
    },
    /** Unidade ligada + 196: a API rejeita mais de uma nota por lançamento. */
    isSingleInvoiceRequired() {
      return this.isLoadNumberRequired && this.docfisIds.length > 1;
    },
    /** Unidade ligada + 196 + nota não dispensada: habilita o código e o torna obrigatório. */
    isReturnCodeEnabled() {
      return this.isLoadNumberRequired && !this.isReturnCodeWaived;
    },
    /** Aviso só onde o campo seria exigido (unidade ligada + 196) e a nota foi dispensada. */
    isReturnCodeNotice() {
      return this.isLoadNumberRequired && this.isReturnCodeWaived;
    },
    /** Tipo e tamanho do anexo só são validados em unidade ligada, como na API. */
    shouldRestrictAttachments() {
      return this.$parent.exigeCodigoDevolucao === true;
    },
    /** Enviar só com os campos obrigatórios preenchidos (carga só na 196 em unidade ligada; código quando habilitado) e sem anexo com erro. O anexo é opcional. */
    isSubmitDisabled() {
      return (
        this.isDisabled ||
        this.isSingleInvoiceRequired ||
        !this.fileForm.cd_ocorrencia ||
        !String(this.fileForm.dt_ocorrencia || "").trim() ||
        this.obsLength < 20 ||
        this.obsLength > 200 ||
        (this.isLoadNumberRequired &&
          !String(this.fileForm.num_carga || "").trim()) ||
        (this.isReturnCodeEnabled &&
          !RETURN_CODE_PATTERN.test(this.fileForm.codigo_devolucao)) ||
        this.attachments.some((item) => item.status !== "ready")
      );
    },
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>

<style>
/* Não scoped: o b-modal renderiza fora do escopo do componente. */
.ocorrencia-modal .modal-content {
  font-family: "Inter", sans-serif;
  background: #ffffff;
  border-radius: 8px;
}
.ocorrencia-modal .modal-header,
.ocorrencia-modal .modal-footer {
  border-color: #f0f0f0;
}
.ocorrencia-form__row {
  display: flex;
  gap: 12px;
}
.ocorrencia-form__row .ocorrencia-form__item {
  flex: 1 1 0;
}
.ocorrencia-form__item {
  margin-bottom: 16px;
}
.ocorrencia-form__label {
  display: block;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.88);
}
.ocorrencia-form__required {
  color: #ff4d4f;
}
.ocorrencia-form__optional {
  color: rgba(0, 0, 0, 0.45);
}
.ocorrencia-form__input,
.ocorrencia-form__textarea {
  width: 100%;
  border: 1px solid #d9d9d9;
  background: #ffffff;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
}
.ocorrencia-form__input {
  height: 40px;
  padding: 0 11px;
  border-radius: 8px;
}
.ocorrencia-form__textarea {
  height: 100px;
  padding: 8px 11px;
  border-radius: 6px;
  resize: none;
}
.ocorrencia-form__input:disabled {
  background: rgba(0, 0, 0, 0.04);
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ocorrencia-form__input--error {
  border-color: #ff4d4f;
}
.ocorrencia-form__error {
  margin: 4px 0 0;
  font-size: 14px;
  line-height: 22px;
  color: #ff4d4f;
}
.ocorrencia-form__notice {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.45);
}
.ocorrencia-form__counter {
  text-align: right;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
}
.ocorrencia-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background: rgba(236, 243, 249, 0.3);
  border: 1.6px dashed #9cbfe2;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
}
.ocorrencia-upload--drag {
  background: rgba(236, 243, 249, 0.7);
}
.ocorrencia-upload__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #c4d9ee;
  color: #234e79;
}
.ocorrencia-upload__title {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.88);
}
.ocorrencia-upload__hint {
  margin: 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.ocorrencia-attachments {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
}
.ocorrencia-attachment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin-bottom: 8px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 14px;
}
.ocorrencia-attachment--error,
.ocorrencia-attachment--error .ocorrencia-attachment__status {
  border-color: #ff4d4f;
  color: #ff4d4f;
}
.ocorrencia-attachment__status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.ocorrencia-attachment__ready {
  color: #52c41a;
}
.ocorrencia-attachment__bar {
  width: 160px;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
}
.ocorrencia-attachment__bar-fill {
  height: 100%;
  background: #234e79;
  border-radius: 2px;
}
.ocorrencia-attachment__actions a {
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.45);
}
.ocorrencia-btn {
  border-radius: 8px;
}
.ocorrencia-btn--back {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  color: rgba(0, 0, 0, 0.88);
}
.ocorrencia-btn--submit {
  margin-left: 1px;
  background: #234e79;
  border-color: #234e79;
  color: #ffffff;
}
.ocorrencia-btn--submit:disabled {
  background: rgba(0, 0, 0, 0.04);
  border-color: #d9d9d9;
  color: rgba(0, 0, 0, 0.25);
}
</style>
